import spacing from '@workday/canvas-space-web';
function stripUnit(value) {
    return parseInt(("" + value).replace('px', ''), 10);
}
export var spacingNumbers = {
    zero: stripUnit(spacing.zero),
    xxxs: stripUnit(spacing.xxxs),
    xxs: stripUnit(spacing.xxs),
    xs: stripUnit(spacing.xs),
    s: stripUnit(spacing.s),
    m: stripUnit(spacing.m),
    l: stripUnit(spacing.l),
    xl: stripUnit(spacing.xl),
    xxl: stripUnit(spacing.xxl),
    xxxl: stripUnit(spacing.xxxl),
};
export default spacing;
